module.exports = __webpack_public_path__ + "img/bg-service-5.a97fdd94.svg";